@if (form && fieldName) {
  <div [formGroup]="form">
    <p-select appendTo="body"
              [styleClass]="styleClass" [class]="class"
              [options]="languages"
              [formControlName]="fieldName"
              [placeholder]="'PLEASE_SELECT' | translate"
              optionLabel="name"
              [optionValue]="valueType === 'object' ? undefined : 'code'"
              (onChange)="this.selectedLanguage = form.controls[fieldName].value; onLanguageChange();"
              [showClear]="showClear"
              class="grid-comp-full-width"/>
  </div>
} @else {
  <p-select appendTo="body"
            [styleClass]="styleClass" [class]="class"
            [options]="languages"
            [placeholder]="'PLEASE_SELECT' | translate"
            optionLabel="name"
            [optionValue]="valueType === 'object' ? undefined : 'code'"
            [(ngModel)]="selectedLanguage"
            (ngModelChange)="onLanguageChange()"
            [showClear]="showClear"
            class="grid-comp-full-width"/>
}

<!--
  <ng-template let-item #item>
    @if (item.code === '--') {
      <p-divider/>
    } @else {
      <div class="flex align-items-center gap-2">
        <span class="fi fi-{{convertFlagCode(item.code)}}"></span>
        {{item.name}}
      </div>
    }
  </ng-template>
  <ng-template let-item #selectedItem>
    <div class="flex align-items-center gap-2">
      <span class="fi fi-{{convertFlagCode(item.code)}}"></span>
      {{item.name}}
    </div>
  </ng-template>
  -->
